import { cn } from '@seen/ui'
import type { JSX } from 'react'

export function IconFax({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={cn('size-4 shrink-0', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="6" width="12" height="8" rx="1" />
      <path d="M4 6V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3" />
      <rect x="4" y="9" width="2" height="2" rx="0.5" />
      <rect x="7" y="9" width="2" height="2" rx="0.5" />
      <rect x="10" y="9" width="2" height="2" rx="0.5" />
    </svg>
  )
}
